function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.974 3.161c-.495 0-.897.434-.897.968v7.742c0 .534.402.968.897.968.496 0 .898-.434.898-.968V8c0-1.176.884-2.129 1.974-2.129h5.205v-.194c0-.534-.402-.967-.897-.967H7.059L5.623 3.16H2.974zm2.872 3.871c-.495 0-.897.434-.897.968v3.871c0 .348-.078.677-.216.968h8.293c.495 0 .897-.434.897-.968V8c0-.534-.402-.968-.897-.968h-7.18zM2.974 14C1.884 14 1 13.047 1 11.871V4.129C1 2.953 1.884 2 2.974 2H6.07l1.436 1.548h2.649c1.09 0 1.974.954 1.974 2.13v.193h.898C14.116 5.871 15 6.824 15 8v3.871C15 13.047 14.116 14 13.026 14H2.974z",
  fill: "#2D2D2D"
});
function SvgArchivoabierto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Archivo abierto.svg";
export { SvgArchivoabierto as ReactComponent };